<div class="employee-sign-up-success">
  <div class="content">
    <img
      ngSrc="assets/graphic-employee-signup-success.svg"
      alt=""
      class="d-md-none"
      height="142"
      width="212" />
    <h2 class="mt-5 mt-md-0">Success!</h2>
    @if (isAdminUser()) {
      <p class="lead mb-4">Registration completed.</p>
      <button
        class="btn btn-primary btn-lg"
        (click)="toDashboard()">
        Continue
        <i class="ms-2 iconoir-arrow-right"></i>
      </button>
    } @else {
      <p><strong>Password created.</strong></p>
      <p>Use your company email and new password to sign in to your Paystashio app.</p>
      <app-download-app-buttons></app-download-app-buttons>
    }
  </div>
</div>
